import { camelCase } from 'lodash'
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import PollOutlinedIcon from '@mui/icons-material/PollOutlined'
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined'
import AutoStoriesOutlinedIcon from '@mui/icons-material/AutoStoriesOutlined'
import HelpCenterOutlinedIcon from '@mui/icons-material/HelpCenterOutlined'
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined'
import NewspaperOutlinedIcon from '@mui/icons-material/NewspaperOutlined'
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined'
import MapOutlinedIcon from '@mui/icons-material/MapOutlined'
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined'
import RoomOutlinedIcon from '@mui/icons-material/RoomOutlined'

import { ActivityType } from 'types/ViewActivities'
import {
  toolNameWithOnPreposition,
  projectNameWithInPreposition,
  toolTypeWithFromPreposition,
  toolTypeWithInPreposition,
  toolTypeWithOnPreposition,
} from 'components/ParticipantProfile/ViewActivities/Constants'

export const titleCreator = (obj: ActivityType) => {
  const { trackableName = '', trackableType = '', projectName = '' } = obj
  const eventType = obj?.eventType
    ? `${camelCase(obj.eventType.replace(':', '_'))}`
    : ''
  const createdAt = obj?.createdAt || ''
  const toolLink = obj?.permalink || ''
  const titleEventName = `participantActivities.titleEventName.${camelCase(
    eventType.replace(':', '_'),
  )}`
  const titleToolName = createToolNamePhrase(eventType)
  const titleToolType = createToolTypePhrase(eventType)
  const titleProjectName = createProjectPhrase(eventType)
  const icon = iconForActivity(trackableType)
  return {
    titleEventName,
    titleProjectName,
    titleToolName,
    titleToolType,
    createdAt,
    toolLink,
    trackableName,
    trackableType,
    projectName,
    eventType,
    icon,
  }
}

export const iconForActivity = (eventType: string) => {
  switch (eventType) {
    case 'ForumTopic':
      return ForumOutlinedIcon
    case 'QuickPoll':
      return PollOutlinedIcon
    case 'SurveyTool':
      return AssignmentOutlinedIcon
    case 'StoryTellingTool':
      return AutoStoriesOutlinedIcon
    case 'Qanda':
      return HelpCenterOutlinedIcon
    case 'Ideas':
      return LightbulbOutlinedIcon
    case 'BlogPost':
      return NewspaperOutlinedIcon
    case 'GuestBook':
      return MenuBookOutlinedIcon
    case 'Map':
      return MapOutlinedIcon
    case 'SignupFormResponse':
      return BadgeOutlinedIcon
    case 'Marker':
      return RoomOutlinedIcon
    default:
      return AccessTimeIcon
  }
}

const createToolNamePhrase = (eventType: string) => {
  if (toolNameWithOnPreposition.includes(eventType)) {
    return `participantActivities.titleToolName.withOnPreposition`
  } else {
    return `participantActivities.titleToolName.withoutPreposition`
  }
}

const createProjectPhrase = (eventType: string) => {
  if (projectNameWithInPreposition.includes(eventType)) {
    return `participantActivities.titleProjectName.withInPreposition`
  } else {
    return `participantActivities.titleProjectName.withComma`
  }
}

const createToolTypePhrase = (eventType: string) => {
  if (toolTypeWithInPreposition.includes(eventType)) {
    return `participantActivities.titleToolType.withInPreposition`
  } else if (toolTypeWithOnPreposition.includes(eventType)) {
    return `participantActivities.titleToolType.withOnPreposition`
  } else if (toolTypeWithFromPreposition.includes(eventType)) {
    return `participantActivities.titleToolType.withFromPreposition`
  } else if (eventType == 'ideaAdded') {
    return `participantActivities.titleToolType.withToPreposition`
  } else {
    return ``
  }
}
